/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ResponseVisitDto } from '../models/response-visit-dto';
import { visitsControllerCreate } from '../fn/visits/visits-controller-create';
import { VisitsControllerCreate$Params } from '../fn/visits/visits-controller-create';
import { visitsControllerDelete } from '../fn/visits/visits-controller-delete';
import { VisitsControllerDelete$Params } from '../fn/visits/visits-controller-delete';
import { visitsControllerFilter } from '../fn/visits/visits-controller-filter';
import { VisitsControllerFilter$Params } from '../fn/visits/visits-controller-filter';
import { visitsControllerFindOne } from '../fn/visits/visits-controller-find-one';
import { VisitsControllerFindOne$Params } from '../fn/visits/visits-controller-find-one';
import { visitsControllerUpdate } from '../fn/visits/visits-controller-update';
import { VisitsControllerUpdate$Params } from '../fn/visits/visits-controller-update';

@Injectable({ providedIn: 'root' })
export class VisitsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `visitsControllerCreate()` */
  static readonly VisitsControllerCreatePath = '/thalea-pathways/visits';

  /**
   * Create a visit.
   *
   * Creates a new visit record.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitsControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visitsControllerCreate$Response(params: VisitsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseVisitDto>> {
    return visitsControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a visit.
   *
   * Creates a new visit record.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `visitsControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visitsControllerCreate(params: VisitsControllerCreate$Params, context?: HttpContext): Observable<ResponseVisitDto> {
    return this.visitsControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseVisitDto>): ResponseVisitDto => r.body)
    );
  }

  /** Path part for operation `visitsControllerFindOne()` */
  static readonly VisitsControllerFindOnePath = '/thalea-pathways/visits/{tenant}/{id}';

  /**
   * Find a visit by id.
   *
   * Finds a visit by id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitsControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitsControllerFindOne$Response(params: VisitsControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseVisitDto>> {
    return visitsControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Find a visit by id.
   *
   * Finds a visit by id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `visitsControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitsControllerFindOne(params: VisitsControllerFindOne$Params, context?: HttpContext): Observable<ResponseVisitDto> {
    return this.visitsControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseVisitDto>): ResponseVisitDto => r.body)
    );
  }

  /** Path part for operation `visitsControllerUpdate()` */
  static readonly VisitsControllerUpdatePath = '/thalea-pathways/visits/{tenant}/{id}';

  /**
   * Update a visit.
   *
   * Updates an existing visit record.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitsControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visitsControllerUpdate$Response(params: VisitsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseVisitDto>> {
    return visitsControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a visit.
   *
   * Updates an existing visit record.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `visitsControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visitsControllerUpdate(params: VisitsControllerUpdate$Params, context?: HttpContext): Observable<ResponseVisitDto> {
    return this.visitsControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseVisitDto>): ResponseVisitDto => r.body)
    );
  }

  /** Path part for operation `visitsControllerDelete()` */
  static readonly VisitsControllerDeletePath = '/thalea-pathways/visits/{tenant}/{id}';

  /**
   * Delete a visit.
   *
   * Deletes a visit record.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitsControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitsControllerDelete$Response(params: VisitsControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return visitsControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a visit.
   *
   * Deletes a visit record.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `visitsControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitsControllerDelete(params: VisitsControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.visitsControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `visitsControllerFilter()` */
  static readonly VisitsControllerFilterPath = '/thalea-pathways/visits/filter';

  /**
   * Filter visits based on query parameters.
   *
   * Retrieves visits filtered based on query parameters.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitsControllerFilter()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visitsControllerFilter$Response(params: VisitsControllerFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseVisitDto>>> {
    return visitsControllerFilter(this.http, this.rootUrl, params, context);
  }

  /**
   * Filter visits based on query parameters.
   *
   * Retrieves visits filtered based on query parameters.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `visitsControllerFilter$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visitsControllerFilter(params: VisitsControllerFilter$Params, context?: HttpContext): Observable<Array<ResponseVisitDto>> {
    return this.visitsControllerFilter$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ResponseVisitDto>>): Array<ResponseVisitDto> => r.body)
    );
  }

}
